import React from 'react'
import sha1 from 'sha1'

import useUser from '../../hooks/useUser'
import Script from './Script'

const Identify = (): JSX.Element => {
  let hashedEmail = ''
  const { email } = useUser()

  if (email) {
    hashedEmail = sha1(email)
  }

  return (
    <Script
      innerHTML={`ire('identify', {customerId: '${hashedEmail}', customerEmail: '${hashedEmail}'});`}
    />
  )
}

export default Identify
